// 서버가 결제 자체를 거절하는 두 경우(PG 미가입 지점 4221 / HTTP 422, 직접결제 계정 이상 5032 / HTTP 503)의 손님용 문구를 꺼낸다.
// 코드는 본문 최상위 errorCode 가 우선(실제 서버 모양 {resultCode, message, errorCode}), data 안은 구 모양 폴백이고, 코드가 없을 때만 상태+문구로 가른다.
// 해당 없으면 null — 4091·401/403·409 등 다른 오류는 호출부의 기존 처리가 그대로 맡는다.
const UNREGISTERED = '이 매장은 지금 온라인 결제를 받지 않습니다. 매장에 문의해 주세요.';
const ACCOUNT_BLOCKED = '지금은 이 매장의 결제를 진행할 수 없습니다. 매장에 문의해 주세요.';

export const serverBlockMessage = (error) => {
    const res = error?.response;
    const body = res?.data;
    const info = body?.data ?? body;
    const code = String(body?.errorCode ?? info?.errorCode ?? '');
    const status = Number(res?.status ?? body?.resultCode);
    const text = typeof info?.message === 'string' ? info.message : (typeof body?.message === 'string' ? body.message : '');
    if (code === '4221' || (status === 422 && /온라인 결제를 받지 않/.test(text))) return text || UNREGISTERED;
    if (code === '5032' || (status === 503 && /결제를 진행할 수 없/.test(text))) return text || ACCOUNT_BLOCKED;
    return null;
};
